// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1piJ4","header":"ClearentDisclaimer_header__2mTqS","inner":"ClearentDisclaimer_inner__1q7np"};